import { Attr, HasMany, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { Meter } from "./meter"

@Model()
export class MeterSourceType extends ApplicationRecord {
  public static readonly jsonapiType = "meter_source_types"

  @HasMany("meters") meter!: Meter

  @Attr() name!: string

  @Attr() resourceTypeCode!: string
}
